import { AbstractControl } from '@angular/forms';

export function ValidateDateFuture(control: AbstractControl) {
  if (control.value && new Date(control.value) < new Date()) {
    return { validDate: true };
  }
  return null;
}


// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/validators/dateFuture.validator.ts